import MessagesView from './MessagesView'; 

export default MessagesView;